import { Component, OnInit } from '@angular/core';
import { PopupComponent } from '../../popup.component';
import { ApiService } from 'angular-lib';
import { PopupService } from '../../../../services/popup.service';
import { AbuseType } from 'angular-lib/src/models/abuse-type';

@Component({
    selector: 'ez-popup-report',
    template: require('./popup-report.component.html'),
    styles: [require('./popup-report.component.less')]
})
export class ReportPopupComponent extends PopupComponent implements OnInit {
    private reason: number = 0;
    public abuseTypes: Array<AbuseType>;
    private displayName: string;

    constructor(popupService: PopupService, private apiService: ApiService) {
        super(popupService);
    }

    public ngOnInit() {
        // get the profile name if exists
        if (this.hasData('displayName')) {
            this.displayName = this.getData('displayName');
        } else {
            this.displayName = '';
        }
        if (this.hasData('abuseTypes')) {
            this.abuseTypes = this.getData('abuseTypes');
        } else {
            this.abuseTypes = [];
        }
    }

    public accept() {
        if (this.reason > 0) {
            this.sendResult({
                reason: this.reason
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/popup/types/report/popup-report.component.ts